var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParameterV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    className: "sensor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.sensor .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#CDD0D4;}\n\t.sensor .st1{fill:#74797D;}\n\t.sensor .st2{opacity:0.5;enable-background:new    ;}\n\t.sensor .st3{fill-rule:evenodd;clip-rule:evenodd;fill:#74797D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,5.5h17c0.6,0,1,0.4,1,1v12c0,0.6-0.4,1-1,1h-17c-0.6,0-1-0.4-1-1v-12C2.5,5.9,2.9,5.5,3.5,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.5,20h-17C2.7,20,2,19.3,2,18.5v-12C2,5.7,2.7,5,3.5,5h17C21.3,5,22,5.7,22,6.5v12C22,19.3,21.3,20,20.5,20 z M3.5,6C3.2,6,3,6.2,3,6.5v12C3,18.8,3.2,19,3.5,19h17c0.3,0,0.5-0.2,0.5-0.5v-12C21,6.2,20.8,6,20.5,6H3.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4.8,10.4C6.9,8.8,9.4,8,12,8c2.7,0,5.2,0.9,7.2,2.4l-0.6,0.8C16.7,9.8,14.4,9,12,9c-2.5,0-4.8,0.8-6.6,2.2 L4.8,10.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10,20l4-9.5V20H10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameterV2);
export default __webpack_public_path__ + "static/media/parameter-v-2.855a427f1be736c1b43127d09d382d0d.svg";
export { ForwardRef as ReactComponent };